import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  backButton: {
    alignSelf: 'flex-start',
    paddingInlineStart: 0
  },

  codeBlock: {
    maxHeight: 320,
    margin: 0,
    padding: 12,
    overflow: 'auto',
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusSM,
    background: token.colorFillQuaternary,
    color: token.colorText,
    fontFamily: token.fontFamilyCode,
    fontSize: 12,
    lineHeight: 1.6,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  }
}))
